import {
  JCodeDetails,
  JCodeDocuments,
  MedicalPaOrder,
} from "../../../data-model/medicalPaOrdersModel";

// TypeScript interfaces for the CPT codes data structure
// export interface JCodeObject {
//   j_code: string;
//   doc_id: string;
//   doc_path: string;
//   doc_type: string;
// }

export const saveExistingJCodeDocsToLocalStorage = (
  singleMedicalPaOrder: MedicalPaOrder,
) => {
  // try {
  //   if (!singleMedicalPaOrder?.auth_on_file?.auth_entries) {
  //     return;
  //   }

  //   const authEntries = singleMedicalPaOrder.auth_on_file.auth_entries;
  //   const statusToJCodesMap: StatusToJCodesMap = {};

  //   authEntries.forEach((entry: any) => {
  //     if (entry?.j_codes && Array.isArray(entry.j_codes)) {
  //       entry.j_codes.forEach((jCodeItem: any) => {
  //         if (!jCodeItem?.j_code) {
  //           return;
  //         }

  //         const status = jCodeItem?.auth_status || "Unknown";
  //         const getAllDocsRequired =
  //           statusToDocumentUploadMap[status]?.documents || [];

  //         const jCodeDocs = jCodeItem?.documents || [];

  //         let jCodeDocStatus = {};
  //         if (jCodeDocs && jCodeDocs.length > 0) {
  //           getAllDocsRequired.forEach((doc: any) => {
  //             const isDocPresent = jCodeDocs.some(
  //               (jCodeDoc: any) =>
  //                 jCodeDoc.doc_type === doc.doc_type &&
  //                 jCodeDoc?.doc_path !== "" &&
  //                 jCodeDoc?.doc_path !== null,
  //             );
  //             jCodeDocStatus[doc.doc_type] = isDocPresent;
  //           });
  //         } else {
  //           getAllDocsRequired.forEach((doc: any) => {
  //             jCodeDocStatus[doc.doc_type] = false;
  //           });
  //         }

  //         // Create JCodeObject with actual document data from jCodeDocs
  //         if (jCodeDocs && jCodeDocs.length > 0) {
  //           jCodeDocs.forEach((jCodeDoc: any) => {
  //             if (jCodeDoc?.doc_type && jCodeDoc?.doc_path) {
  //               const jCodeObject: JCodeObject = {
  //                 j_code: jCodeItem?.j_code || "",
  //                 doc_id: jCodeDoc?.id || jCodeItem?.id || "",
  //                 doc_path: jCodeDoc?.doc_path || "",
  //                 doc_type: jCodeDoc?.doc_type || "",
  //               };

  //               if (!statusToJCodesMap[status]) {
  //                 statusToJCodesMap[status] = [];
  //               }
  //               statusToJCodesMap[status].push(jCodeObject);
  //             }
  //           });
  //         } else {
  //           // If no documents exist, create a placeholder object with available data
  //           const jCodeObject: JCodeObject = {
  //             j_code: jCodeItem?.j_code || "",
  //             doc_id: jCodeItem?.id || jCodeItem?.j_code || "",
  //             doc_path: "",
  //             doc_type: "",
  //           };

  //           if (!statusToJCodesMap[status]) {
  //             statusToJCodesMap[status] = [];
  //           }
  //           statusToJCodesMap[status].push(jCodeObject);
  //         }
  //       });
  //     }
  //   });

  //   console.log("statusToJCodesMap", Object.keys(statusToJCodesMap).length);

  //   if (Object.keys(statusToJCodesMap).length > 0) {
  //     setItemInLocalStorage(
  //       LocalStorageKeys.EXISTING_JCODE_DOCS,
  //       statusToJCodesMap,
  //     );
  //   } else {
  //     console.log("No CPT codes data to save");
  //   }
  // } catch (error) {
  //   console.error("Error saving CPT codes to local storage:", error);
  // }

  // existing doc logic saved here
  const jCodes = getAllJCodes(singleMedicalPaOrder);
  if (jCodes && jCodes.length > 0) {
    const allDocs = getAllDocsFromEveryJcodes(jCodes);
    return allDocs;
  }
};

export const getAllJCodes = (medicalPaOrder: MedicalPaOrder) => {
  const authEntries = medicalPaOrder?.auth_on_file?.auth_entries;
  if (!authEntries) return undefined;
  const jCodes = authEntries
    ?.map((entry: any) => entry?.j_codes)
    .flat()
    .filter((jCode): jCode is JCodeDetails => jCode != null);
  return jCodes;
};

export const getAllDocsFromEveryJcodes = (jcodes: JCodeDetails[]) => {
  const docs = jcodes?.map((jcode) => {
    return {
      identifier: jcode?.id,
      documents: jcode?.documents,
    };
  });

  return docs;
};

export const getChangedDocs = (
  docFromDb: {
    identifier: string | undefined;
    documents: JCodeDocuments[] | undefined;
  }[],
  docFromLocalStorage: {
    identifier: string | undefined;
    documents: JCodeDocuments[] | undefined;
  }[],
): {
  identifier: string | undefined;
  documents: JCodeDocuments[];
}[] => {
  const changedDocs = docFromDb
    .map((dbDoc) => {
      const correspondingLocalDoc = docFromLocalStorage.find(
        (local) => local.identifier === dbDoc.identifier,
      );

      // Find only the unique documents (documents that don't exist in localStorage)
      const uniqueDocuments = dbDoc.documents?.filter((dbDocument) => {
        return !correspondingLocalDoc?.documents?.some(
          (localDocument) => localDocument.doc_path === dbDocument.doc_path,
        );
      });

      // Only return the identifier if it has unique documents
      if (uniqueDocuments && uniqueDocuments.length > 0) {
        return {
          identifier: dbDoc.identifier,
          documents: uniqueDocuments, // Only return the unique documents
        };
      }

      return null;
    })
    .filter(
      (
        item,
      ): item is {
        identifier: string | undefined;
        documents: JCodeDocuments[];
      } => item !== null,
    );

  return changedDocs;
};
